import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=8bad5676&"
import script from "./BaseCard.vue?vue&type=script&lang=js&"
export * from "./BaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bad5676')) {
      api.createRecord('8bad5676', component.options)
    } else {
      api.reload('8bad5676', component.options)
    }
    module.hot.accept("./BaseCard.vue?vue&type=template&id=8bad5676&", function () {
      api.rerender('8bad5676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Cards/BaseCard.vue"
export default component.exports